import { request } from "common/components/request";

import { FETCH_REPORTS_START,
    FETCH_REPORTS_SUCCESS,
    MARK_REPORT_START,
    MARK_REPORT_SUCCESS,
    MARK_ALL_REPORTS_READ_SUCCESS }
    from "../reducers/reports_notifications";

export const FETCH_REPORT_NOTIFICATIONS = function() {
    return (dispatch, getState) => {
        const state = getState();
        if (state.common.merchant_ref // Fetch when merchant ref already present
                && state.common.user_permissions.feature_packaged_reports // Fetch when user has permissions
        ) {
            dispatch(FETCH_REPORTS_START());
            return request("/merchant/:merchant_ref/package_reports_notifications", {}).then((data) => {
                dispatch(FETCH_REPORTS_SUCCESS(data));
            });
        }
        
        return Promise.resolve();
    };
};

export const MARK_REPORT_READ = function(id) {
    return (dispatch, getState) => {
        dispatch(MARK_REPORT_START());
        return request("/merchant/:merchant_ref/package_reports_notifications", {
            method: "POST",
            data: { clear: id }
        }).then(() => {
            dispatch(MARK_REPORT_SUCCESS(id));
        });
    };
};

export const MARK_ALL_REPORTS_READ = function() {
    return (dispatch, getState) => {
        dispatch(MARK_REPORT_START({}));
        return request("/merchant/:merchant_ref/package_reports_notifications", {
            method: "POST",
            data: { clear: "all" }
        }).then(() => {
            dispatch(MARK_ALL_REPORTS_READ_SUCCESS());
        });
    };
};
